module.exports = __webpack_public_path__ + "static/media/Item_Weapon_DecoyGrenade_C.61b2020e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Throwable/Item_Weapon_DecoyGrenade_C.png
// module id = 429
// module chunks = 0